/**
 * Gated Video actions
 */
export function createGatedVideoActions(set) {
    return {
        setUnlockedVideoIds: (unlockedVideoIds) => set({ unlockedVideoIds }, false, 'setUnlockedVideoIds'),
        setCheckedVideoIds: (checkedVideoIds) => set({ checkedVideoIds }, false, 'setCheckedVideoIds'),
    };
}
